import { atom } from "recoil";

export const machincesState = atom({
  key: "machincesState",
  default: [],
});
